import { getJson } from './api';

export type OptionalModuleRuntimeState =
  | 'online'
  | 'starting'
  | 'recovering'
  | 'degraded'
  | 'offline'
  | 'disabled'
  | 'not-installed'
  | 'unknown';

export type OptionalModuleItem = {
  id: string;
  displayName: string;
  apiVersion: number;
  lifecycle: 'reserved' | 'development' | 'ready';
  optional: true;
  runtime: 'agent-local' | 'server' | 'external';
  capabilities: readonly string[];
  events: readonly string[];
  runtimeState: OptionalModuleRuntimeState;
  connected: boolean;
  runtimeDetail?: {
    kind: 'wam';
    managed: boolean;
    processState: string;
    restartAttempts: number;
    consecutiveHealthFailures: number;
    lastHealthyAt: string | null;
    nextRetryAt: string | null;
    terminalFailure: boolean;
  };
};

type OptionalModuleResponse = {
  modules?: OptionalModuleItem[];
};

export async function loadOptionalModules(): Promise<OptionalModuleItem[]> {
  const response = await getJson<OptionalModuleResponse>('/api/v1/modules');
  return response.modules ?? [];
}
